import NotificationBanner from "app/pages/sales-intelligence/common-components/NotificationBanner/NotificationBanner";
import styled, { css } from "styled-components";

export const StyledBanner = styled(NotificationBanner)<{ isVisible: boolean }>`
  opacity: 0;
  visibility: hidden;
  transition: opacity 200ms ease-in;

  ${({ isVisible }) =>
      isVisible &&
      css`
          opacity: 1;
          visibility: visible;
      `}
`;
